/** Statuses for individual form sections / subsections. */
export const SectionStatus = {
  NO_STATUS: 'NO STATUS',
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  DELETION_REQUESTED: 'DELETION_REQUESTED',
  DELETION_REJECTED: 'DELETION_REJECTED',
  DELETED: 'DELETED',
} as const;

export type SectionStatusValue = (typeof SectionStatus)[keyof typeof SectionStatus];

/** Statuses for the overall organization version. */
export const OrganizationStatus = {
  DRAFT: 'DRAFT',
  COMPLETED: 'COMPLETED',
  TO_BE_REVIEWED: 'TO_BE_REVIEWED',
  WAITING_TO_BE_SIGNED: 'WAITING_TO_BE_SIGNED',
  NESSUNA_VERSIONE: 'NESSUNA_VERSIONE',
} as const;

export type OrganizationStatusValue = (typeof OrganizationStatus)[keyof typeof OrganizationStatus];
